module.exports = __webpack_public_path__ + "static/media/login_background.fcf91a53.jpg";